'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Llocales_cldr_Symbols(ns, aliasOf, decimal, group, list, percent, minus, perMille, infinity, nan, exp) {
  this.w6 = null;
  this.vY = null;
  this.vZ = null;
  this.w1 = null;
  this.w3 = null;
  this.w8 = null;
  this.w4 = null;
  this.w7 = null;
  this.w2 = null;
  this.w5 = null;
  this.w0 = null;
  this.w6 = ns;
  this.vY = aliasOf;
  this.vZ = decimal;
  this.w1 = group;
  this.w3 = list;
  this.w8 = percent;
  this.w4 = minus;
  this.w7 = perMille;
  this.w2 = infinity;
  this.w5 = nan;
  this.w0 = exp;
}
export { $c_Llocales_cldr_Symbols as $c_Llocales_cldr_Symbols };
$p = $c_Llocales_cldr_Symbols.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Llocales_cldr_Symbols;
/** @constructor */
function $h_Llocales_cldr_Symbols() {
}
export { $h_Llocales_cldr_Symbols as $h_Llocales_cldr_Symbols };
$h_Llocales_cldr_Symbols.prototype = $p;
$p.I = (function() {
  return new $j_java$002elang$002e$002dObject.$c_s_Product$$anon$1(this);
});
$p.m = (function() {
  return $j_java$002elang$002e$002dObject.$m_s_util_hashing_MurmurHash3$().e7(this, (-889275714), null);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Llocales_cldr_Symbols)) {
    var x = this.w6;
    var x$2 = x$0.w6;
    if (((x === null) ? (x$2 === null) : x.f(x$2))) {
      var x$3 = this.vY;
      var x$4 = x$0.vY;
      var $x_9 = ((x$3 === null) ? (x$4 === null) : x$3.f(x$4));
    } else {
      var $x_9 = false;
    }
    if ($x_9) {
      var x$5 = this.vZ;
      var x$6 = x$0.vZ;
      var $x_8 = ((x$5 === null) ? (x$6 === null) : x$5.f(x$6));
    } else {
      var $x_8 = false;
    }
    if ($x_8) {
      var x$7 = this.w1;
      var x$8 = x$0.w1;
      var $x_7 = ((x$7 === null) ? (x$8 === null) : x$7.f(x$8));
    } else {
      var $x_7 = false;
    }
    if ($x_7) {
      var x$9 = this.w3;
      var x$10 = x$0.w3;
      var $x_6 = ((x$9 === null) ? (x$10 === null) : x$9.f(x$10));
    } else {
      var $x_6 = false;
    }
    if ($x_6) {
      var x$11 = this.w8;
      var x$12 = x$0.w8;
      var $x_5 = ((x$11 === null) ? (x$12 === null) : x$11.f(x$12));
    } else {
      var $x_5 = false;
    }
    if ($x_5) {
      var x$13 = this.w4;
      var x$14 = x$0.w4;
      var $x_4 = ((x$13 === null) ? (x$14 === null) : x$13.f(x$14));
    } else {
      var $x_4 = false;
    }
    if ($x_4) {
      var x$15 = this.w7;
      var x$16 = x$0.w7;
      var $x_3 = ((x$15 === null) ? (x$16 === null) : x$15.f(x$16));
    } else {
      var $x_3 = false;
    }
    if ($x_3) {
      var x$17 = this.w2;
      var x$18 = x$0.w2;
      var $x_2 = ((x$17 === null) ? (x$18 === null) : x$17.f(x$18));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$19 = this.w5;
      var x$20 = x$0.w5;
      var $x_1 = ((x$19 === null) ? (x$20 === null) : x$19.f(x$20));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$21 = this.w0;
      var x$22 = x$0.w0;
      return ((x$21 === null) ? (x$22 === null) : x$21.f(x$22));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.b = (function() {
  return $j_java$002elang$002e$002dObject.$m_sr_ScalaRunTime$().ah(this);
});
$p.n = (function() {
  return 11;
});
$p.o = (function() {
  return "Symbols";
});
$p.g = (function(n) {
  switch (n) {
    case 0: {
      return this.w6;
      break;
    }
    case 1: {
      return this.vY;
      break;
    }
    case 2: {
      return this.vZ;
      break;
    }
    case 3: {
      return this.w1;
      break;
    }
    case 4: {
      return this.w3;
      break;
    }
    case 5: {
      return this.w8;
      break;
    }
    case 6: {
      return this.w4;
      break;
    }
    case 7: {
      return this.w7;
      break;
    }
    case 8: {
      return this.w2;
      break;
    }
    case 9: {
      return this.w5;
      break;
    }
    case 10: {
      return this.w0;
      break;
    }
    default: {
      throw $j_java$002elang$002e$002dObject.$ct_jl_IndexOutOfBoundsException__T__(new $j_java$002elang$002e$002dObject.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Llocales_cldr_Symbols(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.e3)));
}
export { $isArrayOf_Llocales_cldr_Symbols as $isArrayOf_Llocales_cldr_Symbols };
var $d_Llocales_cldr_Symbols = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Llocales_cldr_Symbols, "locales.cldr.Symbols", ({
  e3: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Llocales_cldr_Symbols as $d_Llocales_cldr_Symbols };
